module.exports = __webpack_public_path__ + "img/a2-txt2.9ec6ff85.png";